import React from 'react';
import UserInviteForm from './user-invite-form';

import './user-invite.less';

const UserInvite = props => (
  <div className='UserInvite'>
    <h1 className='h2'>Users and Invites</h1>
    <UserInviteForm {...props} />
  </div>
);

export default UserInvite;



// WEBPACK FOOTER //
// ./app/components/settings/user-invite.jsx